import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {HttpRequestErrorHandler} from '@rbaip/ui-component';
import {HttpClient} from '@angular/common/http';
import {ItemSummaryItemSummaryService} from './item-summary-item-summary.service';
import {appConfig} from '../app.config';
import {Asset, AssetPhoto} from '../domain/item';
import {Contract} from '../domain/contract';

@Injectable({
  providedIn: 'root'
})

export class ItemSummaryEquipmentSummaryService extends ItemSummaryItemSummaryService {

  getAssetUrl = '/api/equip/:equipId/details';
  private readonly saveAssetInfoUrl = '/api/asset/:assetId/assetinformation';
  private readonly saveEquipSaleInfoUrl = '/api/equip/:equipId/equipSaleInformationFromAsset';
  private saveEquipInfoUrl = (equipId: number): string => `/api/equip/${equipId}/asset-info`;
  constructor(private http: HttpClient) {
    super();
  }

  public getItem(assetId: number): void {
    let url = this.getAssetUrl;
    url = url.replace(':equipId', assetId.toString());
    this.http.get(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getAsset', {}))
      )
      .subscribe(response => {
        this.data.asset = Object.assign(new Asset(), response);
        const equip = Asset.constructFromObjectJson(response);
        if (equip) {
          this.assetServiceCallback.next(equip);
        }
      });
  }

  public updateAssetInformation(asset: Asset): Observable<any> {
    const url = this.saveEquipInfoUrl(asset.equipId);
    return this.http.put<any>(url, asset, appConfig.httpOptions)
      .pipe(
        map(response => response.data),
        catchError(HttpRequestErrorHandler.handleError('saveAssetInfo', false))
      );
  }


  public updateSaleInformation(asset: Asset): Observable<any> {
    const url = this.saveEquipSaleInfoUrl.replace(':equipId', String(asset.equipId));
    return this.http.post<any>(url, asset, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('saveAssetInfo', false))
      );
  }

  getContractInfo(itemId: number): Observable<Contract> {
    const url = `/api/item/equipment/${itemId}/contract`;
    return this.http.get<Contract>(url, appConfig.httpOptions)
      .pipe(
        catchError(HttpRequestErrorHandler.handleError('getContractInfo')),
        tap(contractData => Contract.fromJson(contractData))
      );
  }

  public getItemPhotos(itemId: number): Observable<AssetPhoto> {
    const url = `/api/equipment/${itemId}/photos`;
    return this.http.get<AssetPhoto>(url, appConfig.httpOptions)
      .pipe(
        tap((assetPhotoJson) => AssetPhoto.fromJson(assetPhotoJson)),
        catchError(HttpRequestErrorHandler.handleError('getItemPhotos', {}))
      );
  }
}
